var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui--content-heading" }, [
    _c("strong", { staticClass: "navbar-brand" }, [
      _vm._v(
        _vm._s(
          _vm.$t(_vm.gcrmTitle) === _vm.gcrmTitle
            ? _vm.title
            : _vm.$t(_vm.gcrmTitle)
        ) + " "
      )
    ]),
    _vm._v(" "),
    _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
      _c(
        "ol",
        { staticClass: "breadcrumb float-right" },
        [
          _vm.home
            ? _c(
                "li",
                { staticClass: "breadcrumb-item" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "mainIndexPage" } } },
                    [_vm._v(_vm._s(_vm.homeText))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.list, function(item, index) {
            return _c(
              "li",
              {
                key: item.menuId,
                staticClass: "breadcrumb-item",
                class: { active: index === _vm.list.length - 1 }
              },
              [_c("a", [_vm._v(_vm._s(_vm.getLabel(item)))])]
            )
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e1ff62e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e1ff62e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/control/breadcrumb/Breadcrumb.vue
// module id = null
// module chunks = 